// Toggle the menu open and close when on mobile
export default function showMoreItems() {
    function initDevelopersContainer(container) {
        const developerItems = container.querySelectorAll('[data-item-show]');
        const showMoreBtn = container.querySelector('[data-button-show]');

        function toggleVisibility(elements, startIndex, endIndex, visible) {
            for (let i = startIndex; i < endIndex; i++) {
                elements[i].setAttribute('data-visible', visible);
            }
        }

        showMoreBtn.addEventListener('click', function (event) {
            event.preventDefault();
            const step = parseInt(showMoreBtn.getAttribute('data-step')) || 2;
            const firstHiddenIndex = Array.from(developerItems).findIndex(item => item.getAttribute('data-visible') === 'false');
            if (firstHiddenIndex !== -1) {
                const endIndex = Math.min(firstHiddenIndex + step, developerItems.length);
                toggleVisibility(developerItems, firstHiddenIndex, endIndex, true);

                if (endIndex === developerItems.length) {
                    showMoreBtn.style.display = 'none';
                }
            } else {
                showMoreBtn.style.display = 'none';
            }
        });
    }

    const containers = document.querySelectorAll('[data-container-show]');
    containers.forEach(container => {
        initDevelopersContainer(container);
    });

    // HTML structure
    // <div className="developers-wrapper" data-container-show>
    //     <div className="developer-item" data-item-show data-visible="true">
    //         Developer item 1
    //     </div>
    //     <div className="developer-item" data-item-show data-visible="false">
    //         Developer item 2
    //     </div>
    //     <div className="developer-item" data-item-show data-visible="false">
    //         Developer item 3
    //     </div>
    //     <a href="#" className="show-more-btn" data-button-show data-step="2">View more</a>
    // </div>
}
